module.exports = __webpack_public_path__ + "static/media/2005_Population_totalRate.bea19d5f.png";